/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 30 to 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const es_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 30 a 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const de_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 30 auf 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const nl_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 30 naar 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const fr_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 30 à 39 : ((39 − 30) ÷ 30) × 100 = +30 %.`)
};

const it_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 30 a 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const pt_br2_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 30 para 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const pt_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 30 para 39: ((39 − 30) ÷ 30) × 100 = +30%.`)
};

const ja_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30から39へ: ((39 − 30) ÷ 30) × 100 = +30%。`)
};

const zh_pct_change_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 30 到 39：((39 − 30) ÷ 30) × 100 = +30%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_ex4", locale)
	if (locale === "en") return en_pct_change_ex4(inputs)
	if (locale === "es") return es_pct_change_ex4(inputs)
	if (locale === "de") return de_pct_change_ex4(inputs)
	if (locale === "nl") return nl_pct_change_ex4(inputs)
	if (locale === "fr") return fr_pct_change_ex4(inputs)
	if (locale === "it") return it_pct_change_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_ex4(inputs)
	if (locale === "pt") return pt_pct_change_ex4(inputs)
	if (locale === "ja") return ja_pct_change_ex4(inputs)
	return zh_pct_change_ex4(inputs)
};